import { withTranslation } from 'react-i18next'

import GraphRow from './GraphRow'
import { IGraphRowProps } from './interface'

export default withTranslation('user')(GraphRow as React.FunctionComponent<IGraphRowProps>)
